import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment/moment";
import MonthPagingArrow from "../../../../Icon/MonthPagingArrow";
import "../DatePickerModalStyles.scss";
import "../styles.scss";

const CustomHeader = props => {
  const {
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    monthDate,
    currentDate,
    changeMonth,
    changeYear,
    relatedDate,
  } = props;

  useEffect(() => {
    if (relatedDate) {
      changeYear(moment(relatedDate).year());
      changeMonth(moment(relatedDate).month());
    }
  }, [relatedDate]);

  const isCurrentDayFromPrevMonth = useMemo(
    () => moment(monthDate).month() - currentDate.month() === 1,
    [monthDate, currentDate]
  );

  return (
    <div className="header">
      <button
        className="pagin-arrow-button"
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled && !isCurrentDayFromPrevMonth}
        type="button"
      >
        <div className="reverse-icon">
          <MonthPagingArrow />
        </div>
      </button>
      <span className="header-text">{moment(date).format("MMMM YYYY")}</span>
      <button
        className="pagin-arrow-button"
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        type="button"
      >
        <MonthPagingArrow />
      </button>
    </div>
  );
};

CustomHeader.propTypes = {
  date: PropTypes.object.isRequired,
  decreaseMonth: PropTypes.func.isRequired,
  increaseMonth: PropTypes.func.isRequired,
  changeMonth: PropTypes.func.isRequired,
  changeYear: PropTypes.func.isRequired,
  prevMonthButtonDisabled: PropTypes.bool.isRequired,
  nextMonthButtonDisabled: PropTypes.bool.isRequired,
  monthDate: PropTypes.object.isRequired,
  currentDate: PropTypes.object.isRequired,
  relatedDate: PropTypes.object,
};

export default CustomHeader;
